import { render } from "./AdrDatadogDowntime.vue?vue&type=template&id=3f2c137e"
import script from "./AdrDatadogDowntime.vue?vue&type=script&lang=js"
export * from "./AdrDatadogDowntime.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__